<template>
  <div>
    <el-dialog title="编辑" :visible.sync="showEditDialog">
      <el-table :data="items" ref="formData" border tooltip-effect="dark" style="width: 50%;margin: auto;"
        height="250px">
        <el-table-column label="分类名称" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.categoryName" placeholder="请输入" />
          </template>
        </el-table-column>

        <!-- <el-table-column label="商品品类图像" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-upload class="avatar-uploader" :action="$uploadURL" :show-file-list="false" :on-success="function (res, file, fileList) {
                            return handleAddBigImgSuccess(file, scope.$index);
                        }">
                            <img v-if="scope.row.bigImg" :src="scope.row.bigImg" class="avatar"
                                style="width:50px;height:50px" />
                            <i v-else class="el-icon-upload avatar-uploader-icon"></i>
                        </el-upload>
                    </template>
                </el-table-column> -->
        <!-- <el-table-column label="封面图" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-upload
              class="avatar-uploader"
              :action="$uploadURL"
              :show-file-list="false"
              :on-success="
                function (res, file, fileList) {
                  return editLogo(file, scope.$index);
                }
              "
            >
              <img
                v-if="scope.row.logo"
                :src="scope.row.logo"
                class="avatar"
                style="width: 50px; height: 50px"
              />
              <i v-else class="el-icon-upload avatar-uploader-icon"></i>
            </el-upload>
          </template>
        </el-table-column> -->
      </el-table>

      <el-row type="flex" justify="center" style="margin-top: 30px">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: []
    },
    showEditDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    console.log(this.items)
  },
  methods: {
    // 规格图片上传成功处理
    save () {
      this.$emit('saveItem', this.items)
    },
    cancel () {
      this.$emit('cancelItem', this.items)
    },
    editBigImg () {
      this.items.bigImg[index].bigImg = file.response.data.url
      this.$forceUpdate()
    },
    editLogo (file, index) {
      this.items[index].logo = file.response.data.url
    }
  }
}
</script>

<style></style>
